import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "Mentions Légales" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Dernière mise à jour : 04 avril 2025</p>

            <h1>Éditeur du Site</h1>
            <p>
              Le site web https://tangagroup.africa est édité par la société Tanga Africa, société de droit ivoirien, 
              au capital de 5 000 000 FCFA, immatriculée au Registre du Commerce et du Crédit Mobilier (RCCM) 
              sous le numéro CI-ABJ-2023-B-12345, dont le siège social est situé à Abidjan, Côte d'Ivoire.
            </p>
            <p>
              Numéro d'identification fiscale : 1234567890
            </p>
            <p>
              Directeur de la publication : Assohoun Eddy
            </p>

            <h1>Hébergement</h1>
            <p>
              Le site est hébergé par hostinger, société de droit Lithuania, 
              dont le siège social est situé à Jonavos str. 60C, 44192.
            </p>

            <h1>Propriété Intellectuelle</h1>
            <p>
              L'ensemble de ce site relève de la législation ivoirienne et internationale sur le droit d'auteur et la propriété intellectuelle. 
              Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            <p>
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse de Tanga Africa
            </p>
            <p>
              La reproduction des textes de ce site sur un support papier est autorisée, notamment dans un cadre pédagogique, sous réserve du respect des trois conditions suivantes :
            </p>
            <ul>
              <li>Gratuité de la diffusion</li>
              <li>Respect de l'intégrité des documents reproduits (pas de modification ni d'altération)</li>
              <li>Citation claire et apparente de la source sous la forme : "Ce document provient du site Internet de Tanga Africa (https://tangagroup.africa). Les droits de reproduction sont réservés et strictement limités."</li>
            </ul>

            <h1>Protection des Données Personnelles</h1>
            <p>
              Conformément à la loi n°2013-450 du 19 juin 2013 relative à la protection des données à caractère personnel, 
              vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant.
            </p>
            <p>
              Pour exercer ce droit, veuillez nous contacter à l'adresse suivante : hello@tangagroup.africa
            </p>
            <p>
              Pour plus d'informations sur la gestion de vos données personnelles, veuillez consulter notre Politique de Confidentialité.
            </p>

            <h1>Cookies</h1>
            <p>
              Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant à naviguer sur ce site, 
              vous acceptez leur utilisation. Pour plus d'informations sur l'utilisation des cookies, veuillez consulter notre Politique de Cookies.
            </p>

            <h1>Liens Hypertextes</h1>
            <p>
              Le site https://tangagroup.africa peut contenir des liens vers d'autres sites. Tanga Africa. n'est pas responsable 
              du contenu des sites vers lesquels des liens sont établis. Ces liens sont proposés aux utilisateurs du site 
              comme un service. La décision d'activer ces liens appartient exclusivement à l'utilisateur.
            </p>

            <h1>Crédits</h1>
            <p>
              Conception et réalisation : Tanga Africa
            </p>
            <p>
              Photos et illustrations : [Crédits des photos et illustrations]
            </p>

            <h1>Contact</h1>
            <p>
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
            </p>
            <ul>
              <li>Par email : hello@tangagroup.africa</li>
              <li>Par téléphone : +225 27 22 49 49 49</li>
              <li>Par courrier : Tanga Africa, Cocody Riviera Akouedo, Abidjan, Côte d'Ivoire</li>
            </ul>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 